import React from 'react';
export function ServiceDetails() {
  return <section className="py-16 bg-gray-50" data-id="element-298" data-mp="22e2435wlctc7">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-299" data-mp="28piv7i8g3thg">
        {/* Setup & Training */}
        <div id="setup-training" className="flex flex-col md:flex-row items-center mb-20 pt-16 -mt-16" data-id="element-300" data-mp="1uphrlv0sq7ya">
          <div className="md:w-1/2 mb-8 md:mb-0 md:pr-12" data-id="element-301" data-mp="1ypi6thvpyn6e">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uwKBvDz4qhnZiyYZYn3Km8/Setup_Image.png" alt="Startup bookkeeping setup and training" className="rounded-lg shadow-lg w-full h-auto" data-id="element-302" data-mp="1kzohyzk7s2wo" />
          </div>
          <div className="md:w-1/2" data-id="element-303" data-mp="1az5uzvxcs6aj">
            <h3 className="text-2xl md:text-3xl font-bold text-[#3A4A46] mb-4" data-id="element-304" data-mp="1fzsc0uryi1eh">
              Setup & Training
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-305" data-mp="121vf1x9lbsza">
              I'll get everything set up for your business, organize your
              accounts, and show you how to use it-step by step. No stress, just
              a smooth start so you can feel confident with your books.
            </p>
            <ul className="space-y-3 mb-6" data-id="element-306" data-mp="19wip29ihyek8">
              <li className="flex items-start" data-id="element-307" data-mp="19zwnx7ryc5mx">
                <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0" data-id="element-308" data-mp="1nwa8wqvp2p65">
                  ✓
                </span>
                <span className="text-gray-700" data-id="element-309" data-mp="v84m7yl2yq3o">
                  QuickBooks® software setup and configuration
                </span>
              </li>
              <li className="flex items-start" data-id="element-310" data-mp="q7hykgvz1wqr">
                <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0" data-id="element-311" data-mp="14yqvlb27ekdx">
                  ✓
                </span>
                <span className="text-gray-700" data-id="element-312" data-mp="chwoxx42atve">
                  Chart of accounts customization
                </span>
              </li>
              <li className="flex items-start" data-id="element-313" data-mp="7iabbmkbnbm2">
                <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0" data-id="element-314" data-mp="27lchxici4n9f">
                  ✓
                </span>
                <span className="text-gray-700" data-id="element-315" data-mp="2cibes8njv8bb">
                  Training on bookkeeping best practices
                </span>
              </li>
              <li className="flex items-start" data-id="element-316" data-mp="2lczgxpxtw9vw">
                <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0" data-id="element-317" data-mp="2leu0aztgbtxv">
                  ✓
                </span>
                <span className="text-gray-700" data-id="element-318" data-mp="1tm3bvbi0f9j6">
                  Lender-ready financial setup
                </span>
              </li>
            </ul>
            <p className="font-medium text-[#3A4A46] mb-6" data-id="element-319" data-mp="22mri3k15w5li">
              Starting at $500 one-time setup
            </p>
            <a href="https://outlook.office.com/book/MeyerBookkeepingTax@meyerbkt.com/" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#3A4A46] text-white px-5 py-2 rounded hover:bg-[#8A9A5B] transition-colors" data-id="element-320" data-mp="391ad4fskxldu">
              Let's Talk
            </a>
          </div>
        </div>
        {/* Catch-up Bookkeeping */}
        <div id="catchup-bookkeeping" className="flex flex-col-reverse md:flex-row items-center mb-20 pt-16 -mt-16" data-id="element-321" data-mp="3ee7kr61soua3">
          <div className="md:w-1/2 md:pr-12" data-id="element-322" data-mp="35eucggpeqbqy">
            <h3 className="text-2xl md:text-3xl font-bold text-[#3A4A46] mb-4" data-id="element-323" data-mp="35fnamtaavsxh">
              Catch-Up Bookkeeping
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-324" data-mp="30hu5m3kqh4ys">
              If you're behind on your books, you're not alone - most business
              owners are. I can help you catch up, clean up, and move forward
              with peace of mind (and accurate numbers).
            </p>
            <ul className="space-y-3 mb-6" data-id="element-325" data-mp="torpnyvjmjen">
              <li className="flex items-start" data-id="element-326" data-mp="pnze2yz782f7">
                <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0" data-id="element-327" data-mp="po7rqt35bbrg">
                  ✓
                </span>
                <span className="text-gray-700" data-id="element-328" data-mp="11oxyxbompn60">
                  Reconcile bank and credit card accounts
                </span>
              </li>
              <li className="flex items-start" data-id="element-329" data-mp="nskhg2k3hlrj">
                <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0" data-id="element-330" data-mp="rqs052y4cx5d">
                  ✓
                </span>
                <span className="text-gray-700" data-id="element-331" data-mp="irn2rzyan9us">
                  Categorize income and expenses
                </span>
              </li>
              <li className="flex items-start" data-id="element-332" data-mp="43tnyhh18bd9">
                <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0" data-id="element-333" data-mp="9124yeqg29cx">
                  ✓
                </span>
                <span className="text-gray-700" data-id="element-334" data-mp="3r9avn4ptz54b">
                  Clean up your accounting system
                </span>
              </li>
              <li className="flex items-start" data-id="element-335" data-mp="3cjg8ls2lly4b">
                <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0" data-id="element-336" data-mp="3cmc65fajaks8">
                  ✓
                </span>
                <span className="text-gray-700" data-id="element-337" data-mp="3lm8x5nkebvqg">
                  Prepare financial statements
                </span>
              </li>
            </ul>
            <p className="font-medium text-[#3A4A46] mb-6" data-id="element-338" data-mp="3vik9uenwenlf">
              Starting at $100 per month of backlog
            </p>
            <a href="https://outlook.office.com/book/MeyerBookkeepingTax@meyerbkt.com/" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#3A4A46] text-white px-5 py-2 rounded hover:bg-[#8A9A5B] transition-colors" data-id="element-339" data-mp="3qj7ro77z24p6">
              Let's Talk
            </a>
          </div>
          <div className="md:w-1/2 mb-8 md:mb-0" data-id="element-340" data-mp="d5e5z5cynzs7">
            <img src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1500&q=80" alt="Catching up on bookkeeping" className="rounded-lg shadow-lg w-full h-auto" data-id="element-341" data-mp="d6p5gszdildi" />
          </div>
        </div>
        {/* Monthly Bookkeeping */}
        <div id="monthly-bookkeeping" className="flex flex-col md:flex-row items-center mb-20 pt-16 -mt-16" data-id="element-342" data-mp="3kpaild9oxzzb">
          <div className="md:w-1/2 mb-8 md:mb-0 md:pr-12" data-id="element-343" data-mp="3ppy6vr6jc2pu">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/i4odmiHQWB1V9mN9pExEEL/Monthly_Bookkeeping.png" alt="Monthly bookkeeping services" className="rounded-lg shadow-lg w-full h-auto" data-id="element-344" data-mp="3uldi0bd5rkik" />
          </div>
          <div className="md:w-1/2" data-id="element-345" data-mp="2588ma1u4yfmu">
            <h3 className="text-2xl md:text-3xl font-bold text-[#3A4A46] mb-4" data-id="element-346" data-mp="259bd69rgki2r">
              Monthly Bookkeeping
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-347" data-mp="29b5aq96cx5yp">
              Ongoing support to maintain accurate financial records, ensuring
              your business stays compliant and you have the insights needed for
              smart decisions.
            </p>
            <ul className="space-y-3 mb-6" data-id="element-348" data-mp="1s0t1fhgnqyby">
              <li className="flex items-start" data-id="element-349" data-mp="1rxn97tcqfgc0">
                <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0" data-id="element-350" data-mp="1nzftn1u08l2e">
                  ✓
                </span>
                <span className="text-gray-700" data-id="element-351" data-mp="2fp2ffx7mqhsj">
                  Monthly bank and credit card reconciliation
                </span>
              </li>
              <li className="flex items-start" data-id="element-352" data-mp="2bq3hiwkbflal">
                <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0" data-id="element-353" data-mp="26pp7j8z5m19x">
                  ✓
                </span>
                <span className="text-gray-700" data-id="element-354" data-mp="va0hg8qlsm4w">
                  Income and expense categorization
                </span>
              </li>
              <li className="flex items-start" data-id="element-355" data-mp="2vb71bqo1iq8z">
                <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0" data-id="element-356" data-mp="2zdlk6arplq09">
                  ✓
                </span>
                <span className="text-gray-700" data-id="element-357" data-mp="2lg5fb3p2a4am">
                  Monthly financial statements
                </span>
              </li>
              <li className="flex items-start" data-id="element-358" data-mp="3e1yd0yvi2sqj">
                <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0" data-id="element-359" data-mp="3e39lvd3syqoi">
                  ✓
                </span>
                <span className="text-gray-700" data-id="element-360" data-mp="34c5a0m9fblxw">
                  Payroll and sales tax add-ons
                </span>
              </li>
            </ul>
            <p className="font-medium text-[#3A4A46] mb-6" data-id="element-361" data-mp="w7xi6nsi1we">
              Starting at $200 per month
            </p>
            <a href="https://outlook.office.com/book/MeyerBookkeepingTax@meyerbkt.com/" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#3A4A46] text-white px-5 py-2 rounded hover:bg-[#8A9A5B] transition-colors" data-id="element-362" data-mp="5my23hoe60q1">
              Let's Talk
            </a>
          </div>
        </div>
        {/* Tax Preparation */}
        <div id="tax-preparation" className="flex flex-col-reverse md:flex-row items-center pt-16 -mt-16" data-id="element-363" data-mp="1v4uz9lxjhb1l">
          <div className="md:w-1/2 md:pr-12" data-id="element-364" data-mp="17ehdue9gmafz">
            <h3 className="text-2xl md:text-3xl font-bold text-[#3A4A46] mb-4" data-id="element-365" data-mp="12fnzkjmcmfer">
              Tax Preparation
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-366" data-mp="1gfp0u06izour">
              Professional tax preparation for individuals and small businesses.
              Let me help you navigate the tax code, maximize deductions, and
              ensure compliance with all regulations.
            </p>
            <ul className="space-y-3 mb-6" data-id="element-367" data-mp="2mvrcworfbjpx">
              <li className="flex items-start" data-id="element-368" data-mp="2mupx66zgq91v">
                <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0" data-id="element-369" data-mp="xh6gv4sygnav">
                  ✓
                </span>
                <span className="text-gray-700" data-id="element-370" data-mp="nqlinih71ksh">Personal tax returns</span>
              </li>
              <li className="flex items-start" data-id="element-371" data-mp="jp8a30mpv3hv">
                <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0" data-id="element-372" data-mp="jogs4sm1l4a2">
                  ✓
                </span>
                <span className="text-gray-700" data-id="element-373" data-mp="9qssbo9kx6l1">
                  Small business tax returns
                </span>
              </li>
              <li className="flex items-start" data-id="element-374" data-mp="4s96dnuzjuso">
                <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0" data-id="element-375" data-mp="qvzdag5plk6">
                  ✓
                </span>
                <span className="text-gray-700" data-id="element-376" data-mp="1v4f3x48lu4ez">Electronic filing</span>
              </li>
              <li className="flex items-start" data-id="element-377" data-mp="1v2kg9i5y7y77">
                <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0" data-id="element-378" data-mp="3d0yx4bjtvfls">
                  ✓
                </span>
                <span className="text-gray-700" data-id="element-379" data-mp="3mrl97vsc5nzq">Client portal access</span>
              </li>
            </ul>
            <p className="font-medium text-[#3A4A46] mb-6" data-id="element-380" data-mp="3qsdj8r917wx2">Starting at $200</p>
            <a href="/tax-preparation" className="inline-block bg-[#3A4A46] text-white px-5 py-2 rounded hover:bg-[#8A9A5B] transition-colors" data-id="element-381" data-mp="2u3pg111z6e7p">
              Learn More
            </a>
          </div>
          <div className="md:w-1/2 mb-8 md:mb-0" data-id="element-382" data-mp="332avgnc5hd49">
            <img src="https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1500&q=80" alt="Tax preparation services" className="rounded-lg shadow-lg w-full h-auto" data-id="element-383" data-mp="382p68d54z15z" />
          </div>
        </div>
      </div>
    </section>;
}